import { dailySessionNotes } from '../../actions/constant';

const {
  GET_ARCHIVED_DOCUMENTS_SUCCESS,
  GET_ARCHIVED_DOCUMENTS_FAILURE,
  GET_ARCHIVED_DOCUMENTS_LOADING,
  GET_ARCHIVED_DOCUMENTS_RESET,
} = dailySessionNotes;

const initialState: object = {
  response: null,
  loading: false,
  isSuccess: false,
};

export const getArchivedDocumentsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ARCHIVED_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: true,
      };
    }

    case GET_ARCHIVED_DOCUMENTS_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
      };

    case GET_ARCHIVED_DOCUMENTS_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_ARCHIVED_DOCUMENTS_RESET:
      return initialState;

    default:
      return state;
  }
};
